<script lang="ts" setup>
import { useComponentMap } from "~/modules/dtwin/composables/useComponentMap";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUICommon } from "~/modules/dtwin/models/DynamicUICommon.interface";
import { getOptionValue } from "~/modules/dtwin/utils/getOptionValue";

const { componentMap } = useComponentMap();

defineProps<{
  dynamicUi: DynamicUICommon;
  dtwin: Dtwin;
}>();
</script>
<template>
  <template v-if="dynamicUi.formattingProcess">
    <template v-if="dynamicUi.formattingProcess.component">
      <component
        :is="componentMap[dynamicUi.formattingProcess?.component]"
        :property-id="dynamicUi.id"
        :row="dtwin"
      ></component>
    </template>
    <template v-else-if="dynamicUi.formattingProcess.options">
      {{
        getOptionValue(dynamicUi.formattingProcess.options, dynamicUi.id, dtwin)
      }}
    </template>
  </template>
</template>
